import { render, staticRenderFns } from "./cupsExpendChart.vue?vue&type=template&id=63610291&scoped=true&"
import script from "./cupsExpendChart.vue?vue&type=script&lang=js&"
export * from "./cupsExpendChart.vue?vue&type=script&lang=js&"
import style0 from "./cupsExpendChart.vue?vue&type=style&index=0&id=63610291&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63610291",
  null
  
)

export default component.exports